// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  objectId: __t.u64().primaryKey().name("object_id"),
  worldId: __t.u64().name("world_id"),
  cellX: __t.i32().name("cell_x"),
  cellZ: __t.i32().name("cell_z"),
  prefabId: __t.string().name("prefab_id"),
  posX: __t.f32().name("pos_x"),
  posY: __t.f32().name("pos_y"),
  posZ: __t.f32().name("pos_z"),
  rotX: __t.f32().name("rot_x"),
  rotY: __t.f32().name("rot_y"),
  rotZ: __t.f32().name("rot_z"),
  rotW: __t.f32().name("rot_w"),
  scale: __t.f32(),
  placedBy: __t.identity().name("placed_by"),
  placedAt: __t.timestamp().name("placed_at"),
  sourceAssetId: __t.u64().name("source_asset_id"),
  rezzedBy: __t.identity().name("rezzed_by"),
});
